
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[title]",
      function () {
        return require("private-next-pages/blog/[title].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/[title]"])
      });
    }
  